import { requestCommon } from '../libs/axios'

/* 案源创建 */
export const createOrder = (data) =>
  requestCommon.post('/order/v2/orderUser/createOrder', data, { loading: true })

/* 获取系统参数 */
export const getCommonConfigKey = (data) =>
  requestCommon.post('/core/common/config/key', data)

/* 根据服务code 获取服务价格相关信息 */
export const serviceManegeInfo = (serverCode, lawyerId) =>
  requestCommon.post(`/info/serviceManege/info/${serverCode}`, { lawyerId })

/* 律师详情 */
export const oneLawyer = (data) => requestCommon.post('/lawyer/lawyer/oneLawyer', data)

/* 获取用户和律师的服务信息和IM信息 */
export const getServerAndImInfo = (data) => requestCommon.post('/info/caseSourceServerV2/getServerAndImInfo', data)

/* 订单状态查询v2 */
export const queryOrderStatus = (data) =>
  requestCommon.post('/order/v2/orderUser/queryOrderStatus', data)

/* 支付v2 */
export const orderPay = (data) =>
  requestCommon.post('/order/v2/orderUser/pay', data, { loading: true })
/* 快速咨询用户购买服务滚动信息 2.1.0 */
export const fastConsultBuyUsers = (data) => requestCommon.post('/info/lawyer/fastConsult/buyUsers', data)

export const buriedPoint = (params) => requestCommon.post('/burypoint/point', params) // 页面埋点
